function disableScroll(scroll = true) {
  const $html = document.querySelector('html');
  const $body = document.querySelector('body');
  if (scroll) {
    $html.classList.remove('noscroll');
    $body.classList.remove('noscroll');
  } else {
    $html.classList.add('noscroll');
    $body.classList.add('noscroll');
  }
}

// Only works horizontally at the moment
function offscreen(elem, offset, edge) {
  const windowWidth = window.innerWidth;
  const elemWidth = elem.offsetWidth;

  if (edge === 'right') {
    return (elemWidth + offset >= windowWidth);
  } if (edge === 'left') {
    return (offset <= windowWidth);
  }
  throw new Error('Invalid edge parameter');
}

function calcTime(city, offset) {
  // create Date object for current location
  const d = new Date();

  // convert to msec
  // subtract local time zone offset
  // get UTC time in msec
  const utc = d.getTime() + (d.getTimezoneOffset() * 60000);

  // create new Date object for different city
  // using supplied offset
  const nd = new Date(utc + (3600000 * offset));

  // return time as a string
  return nd;
}

export default {
  disableScroll,
  offscreen,
  calcTime,
};
